export default {
  namespaced: true,
  state() {
    return {
      regions: [
        {
          code: "br",
          name: "Brazil",
          language: "pt",
          with_english: true,
        },
        {
          code: "kh",
          name: "Cambodia",
          language: "km",
          with_english: true,
        },
        {
          code: "cn",
          name: "China",
          language: "zh",
          with_english: false,
        },
        {
          code: "id",
          name: "Indonesia",
          language: "id",
          with_english: true,
        },
        {
          code: "jp",
          name: "Japan",
          language: "ja",
          with_english: true,
        },
        {
          code: "kr",
          name: "Korea",
          language: "ko",
          with_english: true,
        },
        {
          code: "my",
          name: "Malaysia",
          language: "en",
          with_english: true,
        },
        {
          code: "th",
          name: "Thailand",
          language: "th",
          with_english: true,
        },
        {
          code: "uk",
          name: "United Kingdom",
          language: "en",
          with_english: true,
        },
        {
          code: "vn",
          name: "Vietnam",
          language: "vi",
          with_english: true,
        },
        {
          code: "roa",
          name: "Rest of Asia",
          language: "en",
          with_english: true,
        },
        {
          code: "roe",
          name: "Rest of Europe",
          language: "en",
          with_english: true,
        },
        {
          code: "row",
          name: "Rest of World",
          language: "en",
          with_english: true,
        },
      ],
    };
  },
  getters: {
    regions(state) {
      return state.regions;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
};
